"use client";
import ErrorPage from "@/components/organisms/error";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return <ErrorPage error={error} />;
}
